import { render, staticRenderFns } from "./m_makevlogskill.vue?vue&type=template&id=0db0106c&scoped=true&"
import script from "./m_makevlogskill.vue?vue&type=script&lang=js&"
export * from "./m_makevlogskill.vue?vue&type=script&lang=js&"
import style0 from "./m_makevlogskill.vue?vue&type=style&index=0&id=0db0106c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db0106c",
  null
  
)

export default component.exports